import { render, staticRenderFns } from "./Portifolio.vue?vue&type=template&id=1cd2664d&"
import script from "./Portifolio.vue?vue&type=script&lang=js&"
export * from "./Portifolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports